var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 53.3324H46.6666C48.5 53.3324 50 51.8324 50 49.9991V33.3324H55.3C58.2666 33.3324 59.7666 29.7324 57.6666 27.6324L42.3666 12.3324C41.0666 11.0324 38.9666 11.0324 37.6666 12.3324L22.3666 27.6324C20.2666 29.7324 21.7333 33.3324 24.7 33.3324H30V49.9991C30 51.8324 31.5 53.3324 33.3333 53.3324ZM20 59.9991H60C61.8333 59.9991 63.3333 61.4991 63.3333 63.3324C63.3333 65.1658 61.8333 66.6658 60 66.6658H20C18.1666 66.6658 16.6666 65.1658 16.6666 63.3324C16.6666 61.4991 18.1666 59.9991 20 59.9991Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.58671746b1fe4cf59a88af4819ca527f.svg";
export { ForwardRef as ReactComponent };